import React, {useState,useEffect} from 'react';
import {Checkbox, notification, Row, Col, Button} from 'antd';
import {permissionService, userServices} from "../../../../services";
import {useFetchNotification} from "../../../../hooks/use-fetch-notification";
import NotificationMessage from "../../../modals/notification-message";
import Spinner from "../../../spinner";
import DividerBlock from "../../../divider-block";
import {notificationServices} from "../../../../services/notification.services";
import AttachTelegramModal from "../../../modals/attach-telegram";
import {PERFORMANCE_DISCIPLINE_CONTROL, REFUSE_DELIVERY} from "../../../../helpers/user_permission.helper";
import i18n from "../../../../i18n";

function NotificationType(type, name, permissions = null) {
    this.type = type;
    this.name = name;
    this.permissions = permissions;

    this.isUserHaveAccess = (user) => {
        if (!this.permissions) {
            return true;
        }

        for (let permission of this.permissions) {
            if (user.isAccessTo(permission)) {
                return true
            }
        }

        return false;
    }
}

export default function UserNotificationSettings() {
    const user = userServices.getUser();

    const channelTypes = [
        {type: 'web', name: i18n.t('consignorPage.userNotificationSettings.chanel.web')},
        {type: 'telegram', name: i18n.t('consignorPage.userNotificationSettings.chanel.telegram')},
        {type: 'email', name: i18n.t('consignorPage.userNotificationSettings.chanel.email')},
        {type: 'push', name: i18n.t('consignorPage.userNotificationSettings.chanel.push')},
    ];

    const notifyTypes = [
        new NotificationType('new_legal_entity_approve_order', i18n.t('consignorPage.userNotificationSettings.docs.1')),
        new NotificationType('agree_legal_entity_approve_order', i18n.t('consignorPage.userNotificationSettings.docs.2')),
        new NotificationType('new_contract_order', i18n.t('consignorPage.userNotificationSettings.docs.3')),
        new NotificationType('agree_contract_order', i18n.t('consignorPage.userNotificationSettings.docs.4')),
        new NotificationType('new_order_delivery', i18n.t('consignorPage.userNotificationSettings.docs.5')),
        new NotificationType('new_order_delivery_counteroffer', i18n.t('consignorPage.userNotificationSettings.docs.6')),
        new NotificationType('agree_order_delivery_counteroffer', i18n.t('consignorPage.userNotificationSettings.docs.7')),
        new NotificationType('refuse_order_delivery_counteroffer', i18n.t('consignorPage.userNotificationSettings.docs.8')),
        new NotificationType('new_delivery_logist', i18n.t('consignorPage.userNotificationSettings.docs.9')),
        new NotificationType('overdue_approve_legal_entity', i18n.t('consignorPage.userNotificationSettings.docs.10'), [PERFORMANCE_DISCIPLINE_CONTROL]),
        new NotificationType('refuse_delivery_action_to_approve', i18n.t('consignorPage.userNotificationSettings.docs.11'), [REFUSE_DELIVERY]),
        new NotificationType('Change_approved_delivery_date', i18n.t('consignorPage.userNotificationSettings.docs.12')),
        new NotificationType('new_tender_logist', i18n.t('consignorPage.userNotificationSettings.docs.13')),
        new NotificationType('new_offer_delivery', i18n.t('consignorPage.userNotificationSettings.docs.14')),
        new NotificationType('edo_workflow', i18n.t('consignorPage.userNotificationSettings.docs.15')),
        new NotificationType('delivery_not_enroute', i18n.t('consignorPage.userNotificationSettings.docs.16')),
    ];

    const [needUpdate, setNeedUpdate] = useState(true);
    const [loading, setLoading] = useState(true);
    const [stopListUpdate, setStopListUpdate] = useState(false);

    const [notificationsSettings, setNotificationSettings] = useState(null);
    const [distributionCentersNotificationSettings, setDistributionCentersNotificationSettings] = useState([]);

    const [{ notifications }] = useFetchNotification(true);

    const [isShowModalAttachTelegram, setIsShowModalAttachTelegram] = useState(false);

    useEffect(() => {
        if (!stopListUpdate) {
            setLoading(false);
            setNeedUpdate(false);
        }
    }, [needUpdate, stopListUpdate]);

    // Получить настройки уведомлений пользователя
    useEffect(() => {
    let user = userServices.getUser();

    userServices
        .getInfo(user.getAuthToken())
        .then((resp) => {
          setNotificationSettings(resp.notificationsSettings);
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('components.notification.titles.getStaffUserInfo'),
            description: err,
          });
        });
    }, []);

    // Получить список
    useEffect(() => {
        notificationServices
            .getDistributionCenterNotificationSettings()
            .then((resp) => {
                setDistributionCentersNotificationSettings(resp);
            })
            .catch((err) => {
                notification.error({
                    message: i18n.t('components.notification.titles.getListForConsignor'),
                    description: err,
                });
            });
    }, []);

  const saveNotificationSetting = (status, type, notifyType) => {
      let notifySettings = notificationsSettings;

      notificationServices
          .switchNotification(status, type, notifyType)
          .then((resp) => {
              if (resp.code === 200) {
                  notification.success({
                      message: i18n.t('components.notification.titles.save'),
                      description: resp.message,
                  });

                  if (!notifySettings[type]) {
                      notifySettings[type] = [];
                  }
                  notifySettings[type][notifyType] = status;
                  setNotificationSettings({...notifySettings});
              } else {
                  notification.error({
                      message: i18n.t('components.notification.titles.save'),
                      description: resp.message,
                  });
              }
          })
          .catch((err) => {
              notification.error({
                  message: i18n.t('components.notification.titles.save'),
                  description: err,
              });
          });
  };

  const renderNotificationSettingsCheckboxes = () => {
      return notifyTypes
          .filter(notifyValue => {
              return notifyValue.isUserHaveAccess(user);
          })
          .map((notifyValue => {
              return channelTypes.map(channelValue => {
                  return (
                      <Col lg={6} sm={24}>
                          <Checkbox
                              name={channelValue.type +'_'+ notifyValue.type}
                              checked={isNotificationSettingChecked(channelValue.type, notifyValue.type)}
                              onChange={(e) => {
                                  let checked = e.target.checked;
                                  saveNotificationSetting(checked, channelValue.type, notifyValue.type);
                              }}
                              style={{fontSize: "10pt", paddingTop: "15px"}}
                          >
                              {notifyValue.name}
                          </Checkbox>
                      </Col>
                  );
              });
          }));
  };

  const renderNotificationSettingsHeader = () => {
              return (
                  <>
                      <Col lg={6} sm={24}>
                          <b>{i18n.t('consignorPage.userNotificationSettings.chanel.web')}</b>
                      </Col>
                      <Col lg={6} sm={24}>
                          <b>{i18n.t('consignorPage.userNotificationSettings.chanel.telegram')}</b>
                      </Col>
                      <Col lg={6} sm={24}>
                          <b>{i18n.t('consignorPage.userNotificationSettings.chanel.email')}</b>
                      </Col>
                      <Col lg={6} sm={24}>
                          <b>{i18n.t('consignorPage.userNotificationSettings.chanel.app')}</b>
                      </Col>
                  </>
              );
  };

  const isNotificationSettingChecked = (channelType, notifyType) => {
      if (notificationsSettings) {
          if (notificationsSettings[channelType]) {
              return notificationsSettings[channelType][notifyType];
          }
      }

      return false;
  };

  const renderDistCentersCheckboxes = () => {
      return distributionCentersNotificationSettings.map((val, index) => {
          return (
              <Col lg={6} sm={24}>
                  <Checkbox
                      name={val.distributionCenter.id}
                      checked={isDistCenterSettingChecked(val.distributionCenter.id)}
                      onChange={(e) => {
                          let checked = e.target.checked;
                          let settings = distributionCentersNotificationSettings;
                          settings[index].isActive = checked

                          saveDistCenterSettings(settings);
                      }}
                      style={{fontSize: "10pt", paddingTop: "15px"}}
                  >
                      {val.distributionCenter.name}
                  </Checkbox>
              </Col>
          );
      });
  }

  const isDistCenterSettingChecked = (distCenterID) => {
      if (distributionCentersNotificationSettings) {
          let val = distributionCentersNotificationSettings.find((value => {
              return value.distributionCenter.id === distCenterID;
          }));

          if (val) {
              return val.isActive;
          }
      }

      return false;
  }

  const saveDistCenterSettings = (settings) => {
      let settingsArr = settings.map((val) => {
          return {
              distributionCenterID: Number(val.distributionCenter.id),
              isActive: val.isActive
          };
      });

      notificationServices
          .saveDistCentersNotifications(settingsArr)
          .then((resp) => {
              notification.success({
                  message: i18n.t('components.notification.titles.save'),
                  description: resp.message,
              });

              setDistributionCentersNotificationSettings([...settings]);
          })
          .catch((err) => {
              notification.error({
                  message: i18n.t('components.notification.titles.save'),
                  description: err,
              });
          });
  }


  let bigButtonStyle = { height: '40px', background: '#1CAA53', position: 'static', borderRadius: '10px', borderColor: "#1CAA53", marginTop: "20px" };
  let telegramButtonStyle = { height: '40px', background: '#1CAA53', position: 'static', borderRadius: '10px', borderColor: "#1CAA53", marginBottom: "20px", float: 'right' };
  return (
      <>
        <NotificationMessage notifications={notifications} setStopListUpdate={setStopListUpdate} loading={false} />

        <Spinner loading={loading}>
            <Row style={{ marginBottom: "25" }}>
                <Col className={"content-header"} style={{ marginBottom: "0px" }} span={12}>{i18n.t('consignorPage.userNotificationSettings.title')}</Col>
                <Button
                    type="primary"
                    htmlType="button"
                    style={telegramButtonStyle}
                    onClick={() => {
                        setIsShowModalAttachTelegram(true);
                    }}
                >
                  {i18n.t('consignorPage.userNotificationSettings.buttons.attachTelegram')}
                </Button>
            </Row>
            <AttachTelegramModal setIsShow={setIsShowModalAttachTelegram} isShow={isShowModalAttachTelegram} />
            <DividerBlock label={i18n.t('consignorPage.userNotificationSettings.divider.notification')} />
            <Row>
                {renderNotificationSettingsHeader()}
                {renderNotificationSettingsCheckboxes()}
            </Row>
            <DividerBlock label={i18n.t('consignorPage.userNotificationSettings.divider.centers')} />
            <Row>
                {renderDistCentersCheckboxes()}
            </Row>
        </Spinner>
      </>
  );
};


